

export const pathHandler = (location) => {
    const signUp = "/signup";
    const login = "/login";
    const basePath = "/";
    const currentPath = location.pathname;

    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role");
    if(!token){
        return login;
    }
    if (token.includes("null")) {
        return login;
    } else {
        if (signUp === currentPath && role.toString() === "ADMIN") {
            return signUp;
        } else if (token!=="null" && currentPath === signUp) {
            return basePath
        } else {
            if (token!=="null") {
                return currentPath;
            } else {
                return login;
            }
        }
    }
}



/**
 * A row count held in localStorage, as a number TablePagination will accept.
 *
 * The key is absent until the first list response lands, and a response carrying no count
 * used to store the string "undefined" - parseInt gives NaN for both, which MUI rejects with
 * "Invalid prop `count` of type `NaN`". Nothing known yet reads as nothing to page through.
 */
export const readStoredCount = (key) => {
    const parsed = parseInt(localStorage.getItem(key), 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

/** Store a row count, or drop the key rather than leave a figure that cannot be read back. */
export const storeCount = (key, value) => {
    const parsed = parseInt(value, 10);
    if (Number.isFinite(parsed)) {
        localStorage.setItem(key, String(parsed));
    } else {
        localStorage.removeItem(key);
    }
};

export const apiErrorBasedRedirection = () => {
    localStorage.clear();
    localStorage.setItem("isSignedIn", false);
    localStorage.setItem("authToken", null);
    window.location.href = "/login";
    console.log("from apiErrorBasedRedirection")
}


// export const isNumber = (val) => typeof val === 'number' && !isNaN(val);


// export const isPathHandlingNeeded = (location) => {

//     // If the client platform is JARVIS and the role is IFRAME_USER, then return the current path
//     // This condition is specific for JARVIS platform
//     // if(clientPlatform === platform_role_info.JARVIS && role === platform_role_info.IFRAME_USER){
//     //         return currentPath;
//     // }

//     const currentPath = location.pathname;
//     const claims = "/claim";
//     const clientPlatform_roles = {
//         IFRAME_USER :"IFRAME_USER",
//         JARVIS:"JARVIS"
//     }
//     const clientPlatform = localStorage.getItem("clientPlatform")
//     if(currentPath.includes(claims)){
//         if(clientPlatform===null || clientPlatform.includes(clientPlatform_roles.JARVIS)){

//             const queryParams = new URLSearchParams(location.search);
//             const data = queryParams.get("data");

//             const pathSplit = currentPath.split("/")
//             console.log("pathSplit", pathSplit)

//             if(currentPath.includes(claims) && isNumber(parseInt(pathSplit[3], 10))){
//                 console.log("Claims page")
//                 return false;

//             }else if(data) {
//                 console.log("Iframe page")
//                 return false;
//             }
//             return true;
//         }
//         return true;
//     }
//     return true;
// }